import React from 'react'

import Sidescroller from "../Video/SideScroller.mp4";
import { Paragraph, Pane } from 'evergreen-ui'
function Sidescrollers(props){
  return (
      <div className="App">
            <video
              autoPlay
              loop
              muted
              style={{
                position: "absolute",
                width: "100%",
                left: "50%",
                top: "50%",
                height: "100%",
                objectFit: "cover",
                transform: "translate(-50%, -50%)",
                zIndex: "-1"
              }}
            >
          <source src ={Sidescroller} type="video/mp4" />

          </video>
          <Pane clearfix>

          <Pane
          background="transparent"
          elevation={0}
          float="right"
          width={500}
          height={150}
          margin={24}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          >
          <Paragraph color="white" marginTop="default">
          My side scroller level is a very simple but difficult platforming level, there are many different obstacles that require the player to think as well as remember how certain mechanics are used.
          </Paragraph>

          </Pane>
            <Pane
            background="transparent"
            elevation={0}
            float="left"
            width={500}
            height={150}
            margin={300}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            >
              <Paragraph color="white" marginTop="default">
              Mechanics are re used in this level to demonstrate the growth the player must make to progress in the level. Some obstacles require the use of a mechanic learned in a previous obstacle.
              </Paragraph>

                </Pane>
              </Pane>
              <Pane
              background="transparent"
              elevation={0}
              float="right"
              width={500}
              height={150}
              margin={3}
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              >
                <Paragraph color="white" marginTop="default">
                The level is short, but the final obstacle is a very difficult jump that must be made, players have choices in how they will over come the different obstacles in the level and with the final jump players can use items previously discovered to help them.
                </Paragraph>

                  </Pane>


          </div>
        );
  };
export default Sidescrollers;
